import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Order from "../../entity/emergency/Order";
import useEmergencyInterventionDemo
    from "../../component/private/intervention/emergency/demo/useEmergencyInterventionDemoServer";

const SERVICE = "service-emergency";
const ENTITY = "orders";

/**
 * @rule-checker exclude
 * @returns {*|void|boolean|{findOneById(*): {select(): (null|*), exec(boolean=): (undefined|*|void|null|boolean|undefined)}}|null|{select(): (null|*), exec(boolean=): (undefined|*|void|null|boolean|undefined)}}
 */
export default function () {
    const {findOneBy} = useApi();
    const state = useSelector;
    const newInstance = data => new Order(data);
    const demo = useEmergencyInterventionDemo();

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec(useCache = true) {
                    if (demo.isLockRequest()) {
                        return demo.handleRequest("GET", SERVICE, ENTITY, "id", id);
                    }

                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application_v7", false, useCache);
                }
            }
        }
    }
}